module.exports = __webpack_public_path__ + "2d22c417d05d98a899b0d43cf8315572.jpeg";